import _createForOfIteratorHelper from "C:\\Users\\Lenovo\\igic-projetos\\Igic-Web\\Template\\Angle\\portal_profcontrol_cliente\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "C:\\Users\\Lenovo\\igic-projetos\\Igic-Web\\Template\\Angle\\portal_profcontrol_cliente\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Lenovo\\igic-projetos\\Igic-Web\\Template\\Angle\\portal_profcontrol_cliente\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
import { MessageType } from "./IHubProtocol";
import { LogLevel } from "./ILogger";
import { TransferFormat } from "./ITransport";
import { NullLogger } from "./Loggers";
import { TextMessageFormat } from "./TextMessageFormat";
var JSON_HUB_PROTOCOL_NAME = "json";
/** Implements the JSON Hub Protocol. */

export var JsonHubProtocol = /*#__PURE__*/function () {
  function JsonHubProtocol() {
    _classCallCheck(this, JsonHubProtocol);

    /** @inheritDoc */
    this.name = JSON_HUB_PROTOCOL_NAME;
    /** @inheritDoc */

    this.version = 1;
    /** @inheritDoc */

    this.transferFormat = TransferFormat.Text;
  }
  /** Creates an array of {@link @microsoft/signalr.HubMessage} objects from the specified serialized representation.
   *
   * @param {string} input A string containing the serialized representation.
   * @param {ILogger} logger A logger that will be used to log messages that occur during parsing.
   */


  _createClass(JsonHubProtocol, [{
    key: "parseMessages",
    value: function parseMessages(input, logger) {
      // The interface does allow "ArrayBuffer" to be passed in, but this implementation does not. So let's throw a useful error.
      if (typeof input !== "string") {
        throw new Error("Invalid input for JSON hub protocol. Expected a string.");
      }

      if (!input) {
        return [];
      }

      if (logger === null) {
        logger = NullLogger.instance;
      } // Parse the messages


      var messages = TextMessageFormat.parse(input);
      var hubMessages = [];

      var _iterator = _createForOfIteratorHelper(messages),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var message = _step.value;
          var parsedMessage = JSON.parse(message);

          if (typeof parsedMessage.type !== "number") {
            throw new Error("Invalid payload.");
          }

          switch (parsedMessage.type) {
            case MessageType.Invocation:
              this._isInvocationMessage(parsedMessage);

              break;

            case MessageType.StreamItem:
              this._isStreamItemMessage(parsedMessage);

              break;

            case MessageType.Completion:
              this._isCompletionMessage(parsedMessage);

              break;

            case MessageType.Ping:
              // Single value, no need to validate
              break;

            case MessageType.Close:
              // All optional values, no need to validate
              break;

            default:
              // Future protocol changes can add message types, old clients can ignore them
              logger.log(LogLevel.Information, "Unknown message type '" + parsedMessage.type + "' ignored.");
              continue;
          }

          hubMessages.push(parsedMessage);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return hubMessages;
    }
    /** Writes the specified {@link @microsoft/signalr.HubMessage} to a string and returns it.
     *
     * @param {HubMessage} message The message to write.
     * @returns {string} A string containing the serialized representation of the message.
     */

  }, {
    key: "writeMessage",
    value: function writeMessage(message) {
      return TextMessageFormat.write(JSON.stringify(message));
    }
  }, {
    key: "_isInvocationMessage",
    value: function _isInvocationMessage(message) {
      this._assertNotEmptyString(message.target, "Invalid payload for Invocation message.");

      if (message.invocationId !== undefined) {
        this._assertNotEmptyString(message.invocationId, "Invalid payload for Invocation message.");
      }
    }
  }, {
    key: "_isStreamItemMessage",
    value: function _isStreamItemMessage(message) {
      this._assertNotEmptyString(message.invocationId, "Invalid payload for StreamItem message.");

      if (message.item === undefined) {
        throw new Error("Invalid payload for StreamItem message.");
      }
    }
  }, {
    key: "_isCompletionMessage",
    value: function _isCompletionMessage(message) {
      if (message.result && message.error) {
        throw new Error("Invalid payload for Completion message.");
      }

      if (!message.result && message.error) {
        this._assertNotEmptyString(message.error, "Invalid payload for Completion message.");
      }

      this._assertNotEmptyString(message.invocationId, "Invalid payload for Completion message.");
    }
  }, {
    key: "_assertNotEmptyString",
    value: function _assertNotEmptyString(value, errorMessage) {
      if (typeof value !== "string" || value === "") {
        throw new Error(errorMessage);
      }
    }
  }]);

  return JsonHubProtocol;
}();